export enum IdentifierPreference {
  CUSIP = 'CUSIP',
  ISIN = 'ISIN',
}
